import React, { useRef } from 'react';
import {
  Typography,
  Popover,
  IconButton,
  Card, CardHeader,
  CardContent,
  Divider,
} from '@mui/material';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import useDialogStatus from '../../hooks/useDialogStatus';
import focusRing from '../../theme/focus';

const InfoPopover = ({
  content,
  title,
}: {
  content: React.ReactElement | string;
  title: string;
}) => {
  const anchorRef = useRef<HTMLButtonElement>(null);

  const { open, openDialog, closeDialog } = useDialogStatus();

  return (
    <>
      <IconButton
        size="small"
        aria-label={`About ${title}`}
        onClick={openDialog}
        ref={anchorRef}
        sx={{
          color: 'text.secondary',
          '&:focus-visible': { boxShadow: focusRing },
        }}
      >
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorRef.current}
        onClose={closeDialog}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Card variant="outlined" sx={{ maxWidth: 300 }}>
          <CardHeader
            title={title}
            slotProps={{
              title: {
                variant: 'inherit',
                fontWeight: 'bold',
                color: 'black',
              },
            }}
            action={(
              <IconButton
                size="small"
                onClick={closeDialog}
              >
                <CancelIcon />
              </IconButton>
            )}
          />
          <Divider />
          <CardContent>
            <Typography>{content}</Typography>
          </CardContent>
        </Card>
      </Popover>
    </>
  );
};

export default InfoPopover;
